// extracted by mini-css-extract-plugin
export default {"departments":"AE-z","departmentHeading":"BE-z","departmentSection":"CE-z","departmentName":"DE-z","departmentLink":"EE-z","expandIcon":"FE-z"};